export class SentStudyListModel {
  OrderId: number;
  AccessionNo: string;

  constructor(OrderId: number, AccessionNo: string) {
    this.OrderId = OrderId;
    this.AccessionNo = AccessionNo;
  }
}
